<template>
  <article :class="{open: showFull}" class="c-content-expand">
    <div class="c-content-expand__description" v-html="content.description"></div>
    <section class="c-content-expand__toggle" v-if="shrinkDescription" :class="type">
      <base-button :asLink="true" @click="toggleContent">
        <span>{{showFull ? 'Show Less' : 'Show More'}}</span>
      </base-button>
    </section>
  </article>
</template>

<script>
export default {
  props: {
    content: {
      type: Object,
      default: () => {}
    },
    type: {
      type: String,
      default: "question"
    }
  },
  methods: {
    toggleContent() {
      this.showFull = !this.showFull;
    }
  },
  data() {
    return {
      showFull: this.shrinkDescription
    };
  },
  computed: {
    shrinkDescription() {
      if (!this.content.description) {
        return false;
      }
      const wordcount = this.content.description.split(" ");
      if (wordcount.length > 50) {
        return true;
      }

      const linecount = this.content.description.split(/<p>/gm);
      if (linecount.length > 5) {
        return true;
      }
      return false;
    }
  }
};
</script>

<style scoped lang="scss">
.c-content-expand {
  position: relative;

  &__description {
    min-height: 150px;
    max-height: 300px;
    overflow: hidden;
  }

  padding-bottom: 10px;

  &__toggle {
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(
      to bottom,
      transparent,
      tint($colour-nhs-core-blue, 6),
      tint($colour-nhs-core-blue, 6)
    );
    width: 100%;
    padding: 50px 0 20px;

    &.idea {
      background: linear-gradient(
        to bottom,
        rgba(
          red(tint($colour-nhs-orange, 6)),
          green(tint($colour-nhs-orange, 6)),
          blue(tint($colour-nhs-orange, 6)),
          0
        ),
        rgba(
          red(tint($colour-nhs-orange, 6)),
          green(tint($colour-nhs-orange, 6)),
          blue(tint($colour-nhs-orange, 6)),
          1
        ),
        rgba(
          red(tint($colour-nhs-orange, 6)),
          green(tint($colour-nhs-orange, 6)),
          blue(tint($colour-nhs-orange, 6)),
          1
        )
      );
    }

    button {
      position: relative;
      padding: 10px 20px 10px 0;
      &:after {
        content: "";
        border: 5px solid transparent;
        border-top-color: $colour-nhs-core-blue;
        position: absolute;
        width: 5px;
        height: 5px;
        top: 50%;
        margin-top: -2.5px;
        right: 5px;
      }
    }
  }

  &.open & {
    &__description {
      max-height: 999vh;
      padding-bottom: 40px;
    }
    &__toggle {
      background: transparent;
      transform: translateY(10px);
    }
  }

  &.open {
    button {
      &:after {
        transform: rotate(180deg);
        top: auto;
        bottom: 50%;
        margin-bottom: -2.5px;
      }
    }
    // overflow: visible;
  }
}
</style>